export const FREESTAR_PUBLISHER = "knowt-com";
export const SIDEBAR_ADS_CONTAINER_ID = "kjqweriokdd3334";
export const STUDY_SESSION_WAIT_TIME = 6_000;
